import React from 'react';
import { isEnabled } from '../features';
const STORAGE_KEY = 'plk_theme';
const LIGHT = 'light';
const DARK = 'dark';
const ThemeContext = /*#__PURE__*/React.createContext({
  theme: LIGHT,
  setTheme: () => {},
  toggleTheme: () => {},
  canToggle: false
});
function applyTheme(theme) {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.theme = theme;
}
function readInitialTheme() {
  const canToggle = isEnabled('darkTheme');
  if (!canToggle) return LIGHT;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === LIGHT || stored === DARK) return stored;
  } catch (e) {
    // localStorage unavailable — fall through
  }
  return LIGHT;
}
export class ThemeProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      theme: readInitialTheme()
    };
    this.setTheme = this.setTheme.bind(this);
    this.toggleTheme = this.toggleTheme.bind(this);
  }
  componentDidMount() {
    applyTheme(this.state.theme);
  }
  setTheme(next) {
    if (!isEnabled('darkTheme')) return;
    if (next !== LIGHT && next !== DARK) return;
    applyTheme(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      // ignore
    }
    this.setState({
      theme: next
    });
  }
  toggleTheme() {
    this.setTheme(this.state.theme === DARK ? LIGHT : DARK);
  }
  render() {
    const value = {
      theme: this.state.theme,
      setTheme: this.setTheme,
      toggleTheme: this.toggleTheme,
      canToggle: isEnabled('darkTheme')
    };
    return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
      value: value
    }, this.props.children);
  }
}
export function useTheme() {
  return React.useContext(ThemeContext);
}
export { ThemeContext, LIGHT, DARK };
export default ThemeProvider;